import { Size } from '@sgme/ui';
import classNames from 'classnames';
import { useFocusRef } from 'hooks/useFocusRef';
import { KeyboardEvent, MouseEvent } from 'react';

interface Props {
  checked: boolean;
  className?: string;
  id?: string;
  e2e?: string;
  size?: Size;
  isSelected: boolean | undefined;
  isReadOnly: boolean | undefined;
  isCustomized: boolean | undefined;
  onKeyDown?: (e: KeyboardEvent<HTMLInputElement>) => void;
  onClick: (e: MouseEvent<HTMLElement>) => void;

  onChanged: (value: boolean) => void;
}

export function CheckboxCell({
  id,
  checked,
  className,
  e2e,
  size = 'md',
  onKeyDown,
  isCustomized,
  isReadOnly,
  isSelected,
  onClick,
  onChanged,
}: Props) {
  const inputRef = useFocusRef(isSelected ?? false);

  const checkBoxId = id ?? e2e ?? 'checkbox-id';
  const e2eCheckbox = e2e ?? `checkbox-${checkBoxId}`;
  const handleOnKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
    onKeyDown?.(e);
    if (e.key === 'Enter' || e.key === ' ') {
      onChanged(!checked);
    }
  };
  return (
    <div
      onClick={onClick}
      className={classNames(
        className,
        {
          'bg-info bg-opacity-20': isSelected && !isReadOnly,
          'bg-secondary bg-opacity-40': isSelected && isReadOnly,
          'text-info': isCustomized,
        },
        `input-group form-check form-check-inline form-check-${size} m-0`,
      )}
    >
      <input
        id={id}
        name={id}
        data-e2e={e2eCheckbox}
        className={classNames('form-check-input', { 'pe-none': isReadOnly })}
        checked={checked}
        onClick={e => {
          onChanged(!checked);
          onClick(e);
        }}
        readOnly={isReadOnly}
        type="checkbox"
        ref={inputRef}
        onKeyDown={handleOnKeyDown}
      />
    </div>
  );
}
